import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import * as modifyMessageActions from './modify-message.actions';
import * as messageSections from './message-section-constants';
import ModifyMessageForm from './modify-message-form';
import { Title } from '../../layout';
import { toastr } from 'react-redux-toastr';
import { ConfirmModalWindow, accessibilityNotificationsEmitter } from '../../common';

const modalText = "No Start or End Date entered. Do you want to publish this notification without a date range?";

export class AddMessageComponent extends Component {

  componentDidMount() {
    const { modifyMessageActions } = this.props;
    const { validateForm } = modifyMessageActions || {};

    validateForm(['newValue'], undefined, ['newValueValidation']);
  }

  componentDidUpdate(prevProps, prevState) {
    const { modifyMessage : prevMessageState } = prevProps;
    const { showDateRangeConfirmModal : wasShowing } = prevMessageState || {};
    const { modifyMessage } = this.props;
    const { showDateRangeConfirmModal : isShowing } = modifyMessage || {};
    if(isShowing && !wasShowing) {
      var modalFocusTarget = document.getElementById('modal-content');
      if(modalFocusTarget) modalFocusTarget.focus();
    }
    else if(!isShowing && wasShowing) {
      var viewFocusTarget = document.getElementById('view');
      if(viewFocusTarget) viewFocusTarget.focus();
    }
  }

  handleAddMessage() {
    const { modifyMessage, modifyMessageActions } = this.props;
    const { newValue, newValueValidation } = modifyMessage;
    const { showAddValidation, showDateRangeConfirmModal } = modifyMessageActions;

    const useDateRange = newValue.get('useDateRange');
    const publishStartDate = newValue.get('publishStartDate');
    const publishEndDate = newValue.get('publishEndDate');
    const confirmSubmit = useDateRange &&
      (publishStartDate === null || publishStartDate === undefined || publishStartDate === "") &&
      (publishEndDate === null || publishEndDate === undefined || publishEndDate === "");

    //if not passing validation
    if(newValueValidation && newValueValidation.length > 0) {
      showAddValidation();
      return;
    }

    //if displaying message on certain days but no dates are set then show confirm modal
    if(confirmSubmit) {
      accessibilityNotificationsEmitter.assertive(modalText);
      showDateRangeConfirmModal();
      return;
    }

    this.saveMessage();
  }

  onConfirmModalClose(e, result) {
    const { modifyMessageActions } = this.props;
    const { closeDateRangeConfirmModal } = modifyMessageActions;

    if(!!result) {
      this.handleUpdateValue(messageSections.dateRangeSection, false);
      this.handleUpdateValue(messageSections.startSection, "");
      this.handleUpdateValue(messageSections.endSection, "");

      this.saveMessage();
    }
    closeDateRangeConfirmModal();
  }

  saveMessage() {
    const { modifyMessageActions, redirectTo } = this.props;
    const { addMessage } = modifyMessageActions;

    addMessage()
    .then(val => {
      toastr.success('Success', 'Notification Added');
      redirectTo('/dashboard-messages');
    })
    .catch(err => {
      toastr.error(err.errorCode, err.errorMessage);
    });
  }

  handleUpdateValue(section, updateVal) {
    const { modifyMessageActions } = this.props;
    const { updateValue, validateForm } = modifyMessageActions || {};

    updateValue(['newValue', section], updateVal);
    validateForm(['newValue'], undefined, ['newValueValidation']);
  }

  render() {
    const { modifyMessage, redirectTo } = this.props;
    const { newValueValidation, newValue, addMessageState, showAddValidation, showDateRangeConfirmModal } = modifyMessage || {};
    const { isFetching } = addMessageState || {};

    const invalidForm = !!newValueValidation && newValueValidation.length > 0;

    return (
      <div>
        <Title title="Add Notification"/>
        <h1>New Notification</h1>
        <ModifyMessageForm
          value={newValue}
          updateValue={(section, updateVal) => this.handleUpdateValue(section, updateVal)}
          disabled={isFetching}
          errors={newValueValidation}
          showErrors={showAddValidation}/>
        <div className="actions">
          <button
            id="publish"
            className="btn btn-primary"
            onClick={e => this.handleAddMessage()}
            disabled={isFetching || invalidForm}>
            Publish
          </button>
          <button
            id="cancel"
            className="btn btn-default"
            onClick={e => redirectTo('/dashboard-messages')}>
            Cancel
          </button>
        </div>

        <ConfirmModalWindow
            show={showDateRangeConfirmModal}
            title={"Publish Notification"}
            onClose={(e, result) => this.onConfirmModalClose(e, result) }>
          <div className="form-horizontal survey">
            <p>{modalText}</p>
          </div>
        </ConfirmModalWindow>
      </div>
    );
  }
}

AddMessageComponent.propTypes = {
  modifyMessage : PropTypes.any,
  modifyMessageActions : PropTypes.any,
  redirectTo : PropTypes.func,
  showDateRangeConfirmModal : PropTypes.bool,
};

const mapStateToProps = ({ modifyMessage }) => {
  return {
    modifyMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyMessageActions: bindActionCreators(modifyMessageActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMessageComponent);
